import type { TFunction } from "i18next";

const marketLocationNumberPattern = /^\d{11}$/;
export const marketLocationNumberLength = 11;

export function validateMarketLocationNumber(
  marketLocationNumber: string | number | null | undefined,
  t: TFunction
): null | string {
  if (marketLocationNumber === null || marketLocationNumber === undefined) {
    return `${t("errors.MarketLocation.InvalidLength", { amount: 0 })}
${t("errors.MeteringOrMarketLocation.ValidationFailedInstructions")}`;
  }

  if (typeof marketLocationNumber === "number") {
    return validateMarketLocationNumber(marketLocationNumber.toString(), t);
  }

  if (marketLocationNumber.length !== marketLocationNumberLength) {
    return `${t("errors.MarketLocation.InvalidLength", { amount: marketLocationNumber.length })}
${t("errors.MeteringOrMarketLocation.ValidationFailedInstructions")}`;
  }

  if (!marketLocationNumberPattern.test(marketLocationNumber)) {
    return `${t("errors.MarketLocation.InvalidCharacter")}
${t("errors.MeteringOrMarketLocation.ValidationFailedInstructions")}`;
  }

  const isCheckDigitValid = validateCheckDigit(
    marketLocationNumber.split("").map(Number)
  );
  if (!isCheckDigitValid) {
    return `${t("errors.MarketLocation.InvalidCheckSum")}
${t("errors.MeteringOrMarketLocation.ValidationFailedInstructions")}`;
  }

  return null;
}

function validateCheckDigit(digitsArray: Array<number>) {
  const sumOfOddIndexedDigits = digitsArray
    .slice(0, digitsArray.length - 1)
    .filter((_, index) => index % 2 === 0)
    .reduce((acc, digit) => acc + digit, 0);
  const sumOfEvenIndexedDigits = digitsArray
    .slice(0, digitsArray.length - 1)
    .filter((_, index) => index % 2 !== 0)
    .reduce((acc, digit) => acc + digit, 0);
  const doubledSumOfEvenIndexedDigits = 2 * sumOfEvenIndexedDigits;
  const totalSum = sumOfOddIndexedDigits + doubledSumOfEvenIndexedDigits;
  const nextMultipleOfTen = Math.ceil(totalSum / 10) * 10;
  const checkDigit = nextMultipleOfTen - totalSum;

  return digitsArray[digitsArray.length - 1] === checkDigit;
}
